import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14 16.9l-5.5-5.4L14 6.1" stroke="currentColor" fill="none" /></svg>;